import React from "react";
import Loader from "../Loader";

const LoaderFinish = () => {
  return (
    <div className="card">
      <div className="card-body btn-success text-center">
        <Loader color="white" />
        <p>Veuillez patienter pendant l'enregistrement de vos données</p>
      </div>
    </div>
  );
};

export default LoaderFinish;
